import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { H2 } from 'components/common/Text/Text'
import { LazyDiv } from 'components/common/LazyHtml'

const BOTShopForTiresUserHtml = ({ title, content }) =>
  <React.Fragment>
    <Heading data-at-heading="shop-for-tires" size={ 18 } bolder noMargin>{ title }</Heading>
    <LazyDiv data-at-shop-for-tires-description content={ content } />
  </React.Fragment>

BOTShopForTiresUserHtml.propTypes = {
  content: PropTypes.string,
  title: PropTypes.string
}

BOTShopForTiresUserHtml.type = 'BOTDescriptionTeaser'

export default BOTShopForTiresUserHtml

const Heading = styled(H2)`
  ${Mixin.font.GothamBold(26, 600)}
  ${Media.mobile`
    ${Mixin.font.GothamBold(22, 600)}
  `}
`
